import React, { useEffect, useState } from 'react';
import './cookiePopup.scss';
import { t } from 'i18next';

const CookieConsentModal = ({ onConsentChange }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');

    if (!consent) {
      setVisible(true);
    } else {
      // restore state on reload
      onConsentChange(consent === 'accepted');
    }
  }, [onConsentChange]);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');

    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
    }

    onConsentChange(true);
    setVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');

    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
      });
    }

    onConsentChange(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-banner">
      <p>{t('cookies.description')}</p>

      <div className="cookie-buttons">
        <button onClick={acceptCookies} className="accept">
          {t('cookies.accept')}
        </button>

        <button onClick={declineCookies} className="reject">
          {t('cookies.reject')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsentModal;
